<template>
  
  <div>
    <header-section></header-section>
    <v-content>
      <breadcrumbs></breadcrumbs>
      <v-container fluid>
        <v-layout row wrap>
          <v-slide-y-transition mode="out-in">
            <router-view />
          </v-slide-y-transition>
        </v-layout>
      </v-container>
    </v-content>
    <footer-section></footer-section>
  </div>

</template>

<script>

  import Breadcrumbs from '../components/Breadcrumbs'
  import Header from '../components/Header'
  import Footer from '../components/Footer'

  export default {
    name: 'Dashboard',
    data () {
      return {
        
      }
    },
    components: {
      'breadcrumbs': Breadcrumbs,
      'header-section': Header,
      'footer-section': Footer
    },
    methods: {

    },
    created () {

    },
  }
  
</script>
